import { FILTERS_DEFAULT_SORTING_VALUES } from '../../../../../lib/constants/courses';
import { FilterSortBy } from '../../../../../lib/utils/search/searchModel';
import { ALL_SORT_BY_OPTIONS, SORT_DIRECTION_OPTIONS } from '../../../../../lib/utils/search/searchHelper';
import { Api } from '../../../../../lib/types/apiSpec';

export const sortToStringValues = (sortBy: FilterSortBy, sortDirection: Api.SortDirection): string =>
  `${sortBy}|${sortDirection}`;

export const stringToSortValues = (value: string): [sortBy: FilterSortBy, sortDirection: Api.SortDirection] => {
  const sortByObject = ALL_SORT_BY_OPTIONS.find(sortBy => value.includes(sortBy));
  const sortDirectionObject = SORT_DIRECTION_OPTIONS.find(sortDirection => value.includes(sortDirection));

  return [
    sortByObject ?? FILTERS_DEFAULT_SORTING_VALUES.SORT_BY,
    sortDirectionObject ?? FILTERS_DEFAULT_SORTING_VALUES.SORT_DIRECTION,
  ];
};
